import { ArrowLeftOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Card, Image } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { CardBody, CardFooter, CardTitle, Col, Row } from "reactstrap";
import { setLoading } from "../../store/slices/auth";
import { getLMSCourseModule, subscribeToCourse } from "./apiController";
import { useDispatch } from "react-redux";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";

const getBadgeType = (result) => {
  switch(result?.toLowerCase()) {
    case 'excellent':
      return { type: 'gold', color: '#FFD700' };
    case 'very good':
      return { type: 'silver', color: '#C0C0C0' };
    case 'good':
      return { type: 'bronze', color: '#CD7F32' };
    case 'poor':
      return { type: 'none', color: '#808080' };
    default:
      return { type: 'none', color: '#808080' };
  }
};

export default function CourseModules(props) {
    const [courselist, Setcourselist] = useState<any>([]);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [loading, Setloading] = useState(true);
    const [badgeStatus, setBadgeStatus] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        let locationData = location.state;
        fetchInitialData(locationData.id, locationData.uid);
    }, []);

    const viewCourse = (data) => {
        let ModuleData = location.state;
        navigate("/modulevideo", {
          state: {
            data: data, 
            moduData: ModuleData.id, 
            uid: ModuleData.uid
          }
        });
    }

    const handleSubscribe = async () => {
        try {
            dispatch(setLoading(true));
            const subResponse = await subscribeToCourse(
              location.state.id, 
              location.state.uid
            );
            if(subResponse) {
                showToaster(toasterTypes.SUCCESS, subResponse.message);
            }
            await fetchInitialData(location.state.id, location.state.uid);
            dispatch(setLoading(false));
        } catch (error) {
            console.error("Subscription failed:", error);
            dispatch(setLoading(false));
        }
    }

    const fetchInitialData = async (id, uid) => {
        try {
            dispatch(setLoading(true));
            let courses = await getLMSCourseModule(id, uid);
            Setcourselist(courses.data);
            setIsSubscribed(courses.subscription_status || false);
            setBadgeStatus(courses.badge_status || '');
            dispatch(setLoading(false));
        } catch (e) {
            dispatch(setLoading(false));
            throw e;
        }
    }

    const Badge = ({ result }) => {
        const { type, color } = getBadgeType(result);
        if (type === 'none') {
            return <div className="module-badge" style={{fontSize:"10px", backgroundColor: "red", borderRadius: "4px", padding: "4px", color: "white" }}>
                Poor Performance
            </div>
            ;
        }
         
        
        return (
            <div className="module-badge">
            <Image src={`${process.env.PUBLIC_URL}/courseBadges/${type}_badge_new.png`} width={50} alt={type}/>
            </div>
        );
    };

    return (
        <>
            <div className="module-container">
                <div className="head-module">
                    <div className="flex items-center">
                        <ArrowLeftOutlined 
                            className="text-white text-2xl mx-2 cursor-pointer"
                            onClick={() => navigate("/learning")} 
                        /> 
                        <span>Modules</span>
                    </div>
                    <div className="flex items-center gap-4">
                        {badgeStatus && (
                            <div className="expected-badge">
                                <span>Expected Course Badge: </span>
                                {getBadgeType(badgeStatus).type !== 'none' &&
                                    <img src={`${process.env.PUBLIC_URL}/courseBadges/${getBadgeType(badgeStatus).type}_badge_new.png`} width={50}/> 
                                }
                                {
                                    getBadgeType(badgeStatus).type === 'none' && 
                                    <div style={{color: "red"}}>
                                        Poor Performance! Need Improvement
                                    </div>
                                }
                            </div>
                        )}
                        {!isSubscribed && (
                            <CustomButton 
                                type="secondary" 
                                text="Subscribe" 
                                onClick={handleSubscribe} 
                            />
                        )}
                    </div>
                </div>
                <div className="module-list">
                    <Row>
                        {courselist?.map((item, id) => (
                            <Col md={3} key={id}>
                                <Card className="module-card relative">
                                    <CardBody>
                                        <Image 
                                            className="thumbnail" 
                                            src={item.thumbnail} 
                                            alt={item.title} 
                                            onLoad={() => setLoading(false)}
                                        />
                                        <span className="description">{item.title}</span>
                                        {item?.user_test_activity[0]?.posttest_result && (
                                            <Badge result={item?.user_test_activity[0]?.posttest_result} />
                                        )}
                                    </CardBody>
                                    <CardFooter>
                                        {isSubscribed ? (
                                            <div 
                                                className="view-module cursor-pointer" 
                                                onClick={() => viewCourse(item)}
                                            >
                                                View Module
                                            </div>
                                        ) : (
                                            <div className="subscription-required text-gray-600 text-center">
                                                Subscription Required
                                            </div>
                                        )}
                                    </CardFooter>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </>
    );
}